// components/LoadingOverlay.js
import React from "react";
import { ClipLoader } from "react-spinners";

const LoadingOverlay = ({ loading }) => {
  if (!loading) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-white/80 dark:bg-gray-950/80 backdrop-blur-[1px] z-[200]">
      <ClipLoader color="#6366F1" loading={true} size={60} />
    </div>
  );
};

export default LoadingOverlay;
